// eslint-disable-next-line @nx/enforce-module-boundaries
import { Endpoints } from '../endpoints'
import { httpClient } from '../http-client'
import { handleErrorResponse } from '../utils'

export namespace Stores {
  export type NfceConfig = {
    enabled: boolean
    cnae: string | null
    uf: string | null
    stateRegistration: string | null
    taxRegime: string | null
    stoneTaxEmitterRegistered: boolean
    certificateFileName: string | null
    certificateExpiresAt: string | null
    certificateDocument: string | null
    numberingSeries: string | null
    numberingNumber: string | null
    deactivatedAt: string | null
    canActivateAt: string | null
  }

  export type Item = {
    id: string
    cnae: string
    name: string
    document: string
    nfceConfig?: NfceConfig
    stateRegistration: string
  }

  export type Request = {
    cnae: string
    stateRegistration: string
  }

  export const getByDocument = async (document: string): Promise<Item> => {
    try {
      const response = await httpClient.get<Item>(Endpoints.stores.getByDocument(document))
      return response.data
    } catch (error: unknown) {
      console.error(error)
      return {
        id: '',
        cnae: '',
        name: '',
        document: '',
        stateRegistration: ''
      }
    }
  }

  export const get = async (id: string): Promise<Item> => {
    try {
      const response = await httpClient.get<Item>(Endpoints.stores.getById(id))
      return response.data
    } catch (error: unknown) {
      return handleErrorResponse(error)
    }
  }

  export const update = async (id: string, payload: Request): Promise<Item> => {
    try {
      const response = await httpClient.patch<Item>(Endpoints.stores.update(id), payload)
      return response.data
    } catch (error: unknown) {
      return handleErrorResponse(error)
    }
  }
}
